var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeatures(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 281,
    height: 99,
    viewBox: "0 0 281 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M281 0H182.048V98.9526H281V0Z",
    fill: "#FAB39D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116.079 98.9526C143.404 98.9526 165.555 76.8013 165.555 49.4763C165.555 22.1513 143.404 0 116.079 0C88.7538 0 66.6025 22.1513 66.6025 49.4763C66.6025 76.8013 88.7538 98.9526 116.079 98.9526Z",
    fill: "#4EB072"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 49.4763C0 76.8002 22.1524 98.9526 49.4763 98.9526V0C22.1524 0 0 22.1524 0 49.4763Z",
    fill: "#91CCD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatures);
export default __webpack_public_path__ + "static/media/Features.f0655d0810b9d445d35eb95cb7858903.svg";
export { ForwardRef as ReactComponent };